import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import serve from "./serve/index.js";
import util from "./util/index.js";
import LoadingPlugin from "vux/src/plugins/loading";
import ToastPlugin from "vux/src/plugins/toast";
import ConfirmPlugin from "vux/src/plugins/confirm";
import VueLazyload from "vue-lazyload";
import Cookies from "js-cookie";

// /* 开启 fundebug 监控 */
// var fundebug = require("fundebug-javascript");
// fundebug.apikey = "dfbf4b279e0f4bb2493d8966efa10a2389226f7234979019b68303951e109594";
Cookies.set("entryUrl", location.href);

// function formatComponentName(vm) {
//   if (vm.$root === vm)
//     return "root";

//   var name = vm._isVue ?
//     (vm.$options && vm.$options.name) || (vm.$options && vm.$options._componentTag) :
//     vm.name;
//   return ((name ?
//     "component <" + name + ">" :
//     "anonymous component") + (vm._isVue && vm.$options && vm.$options.__file ?
//     " at " + (vm.$options && vm.$options.__file) :
//     ""));
// }

// Vue.config.errorHandler = function (err, vm, info) {
//   if (vm) {
//     var componentName = formatComponentName(vm);
//     var propsData = vm.$options && vm.$options.propsData;
//     fundebug.notifyError(err, {
//       metaData: {
//         componentName: componentName,
//         propsData: propsData,
//         info: info
//       }
//     });
//   } else {
//     fundebug.notifyError(err);
//   }
// };
// /* 结束 fundebug 监控 */

Vue.use(VueLazyload);
Vue.use(LoadingPlugin);
Vue.use(ToastPlugin);
Vue.use(ConfirmPlugin);

Vue.config.productionTip = false;
/*判断是否等登录*/
function isLogin() {
  if (Cookies.get("openId")) {
    return true;
  } else {
    return false;
  }
}
Vue.prototype.$http = serve.http;
Vue.prototype.$getUrlQuery = util.getUrlQuery;
Vue.prototype.$isLogin = isLogin;

// 更新当前 cookie 中的 token（馆代码）
if (util.getUrlQuery("token")) {
  Cookies.set("token", util.getUrlQuery("token"), 30);
}
if (Cookies.get("token")) {
  // 根据不同的馆获取 cookie 数据
  let cookieStorageData = util.getLocalStorage(Cookies.get("token")) || {};
  if (cookieStorageData.openId) {
    Cookies.set("openId", cookieStorageData.openId, 30);
    Cookies.set("username", cookieStorageData.username, 30);
    Cookies.set("dzzhao", cookieStorageData.dzzhao, 30);
  }
}

if (util.getUrlQuery("code")) {
  Cookies.set("code", util.getUrlQuery("code"), 30);
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
